import React from 'react';
import { ThemeProvider } from '@atlassian/search-dialog';
import { DialogExpansionContextProvider } from '../dialog-expansion-context';
import { QueryContextProvider } from '../query-context';
import { ProductRouter } from '../product-router';
import { MessagesIntlProvider } from '../../common/message-intl-provider';
import { BuildVersionAnalyticContext } from '../../common/build-version-analytic-context';
import { SearchSessionProvider } from '../../common/search-session-provider';
import { AggregatorClientContextProvider } from '../aggregator-client-context';
import { ABTestContextProvider } from '../ab-test-context';
import { ExperimentExposureHandler } from '../../common/experiment-exposure-handler';
import { DialogDismissedHandler } from '../../common/analytics';
import { UserProvider } from '../../common/user-context';
import { AsyncLoadOnQuery } from './async-load/async-load-on-query';
import { FilterContextHOC } from '../filters/filter-context';
import { AutocorrectionProvider } from '../autocorrection';
import { DialogShownHandler } from '../../common/analytics/dialog-shown-handler';
import { FeaturesProvider } from '../features-context';
import { QuickFindAnalyticContext } from '../../common/quick-find-analytic-context';
import { InputContext } from '../input-context';
import { RovoContextProvider } from '../../common/rovo-context/rovo-context';
import { QueryParamsProvider } from '../query-params-context';
export var MetaContextProvider = function MetaContextProvider(_ref) {
  var _dialogFeatures$quick;
  var children = _ref.children,
    theme = _ref.theme,
    setIsExpanded = _ref.setIsExpanded,
    isExpanded = _ref.isExpanded,
    abTestCloudId = _ref.abTestCloudId,
    aggregatorUrl = _ref.aggregatorUrl,
    experience = _ref.experience,
    clientProviderFeatures = _ref.clientProviderFeatures,
    user = _ref.user,
    orgId = _ref.orgId,
    dialogFeatures = _ref.dialogFeatures,
    primaryProduct = _ref.primaryProduct,
    forwardRef = _ref.forwardRef,
    isRovoEnabled = _ref.isRovoEnabled,
    queryParams = _ref.queryParams;
  return /*#__PURE__*/React.createElement(QueryParamsProvider, {
    queryParams: queryParams
  }, /*#__PURE__*/React.createElement(FeaturesProvider, {
    dialogFeatures: dialogFeatures
  }, /*#__PURE__*/React.createElement(UserProvider, {
    user: user,
    orgId: orgId
  }, /*#__PURE__*/React.createElement(RovoContextProvider, {
    isEnabled: isRovoEnabled
  }, /*#__PURE__*/React.createElement(MessagesIntlProvider, null, /*#__PURE__*/React.createElement(QuickFindAnalyticContext, {
    isQuickFind: dialogFeatures === null || dialogFeatures === void 0 || (_dialogFeatures$quick = dialogFeatures.quickFind) === null || _dialogFeatures$quick === void 0 ? void 0 : _dialogFeatures$quick.enabled
  }, /*#__PURE__*/React.createElement(BuildVersionAnalyticContext, null, /*#__PURE__*/React.createElement(ThemeProvider, {
    partialSearchCSS: theme
  }, /*#__PURE__*/React.createElement(DialogExpansionContextProvider, {
    isExpanded: isExpanded,
    setIsExpanded: setIsExpanded
  }, /*#__PURE__*/React.createElement(ProductRouter, {
    primaryProduct: primaryProduct
  }, /*#__PURE__*/React.createElement(AggregatorClientContextProvider, {
    abTestCloudId: abTestCloudId,
    aggregatorUrl: aggregatorUrl,
    features: clientProviderFeatures
  }, /*#__PURE__*/React.createElement(ABTestContextProvider, {
    experience: experience
  }, /*#__PURE__*/React.createElement(SearchSessionProvider, {
    sessionKey: "ssid_provider_".concat(isExpanded)
  }, isExpanded ? /*#__PURE__*/React.createElement(ExperimentExposureHandler, null) : null, /*#__PURE__*/React.createElement(QueryContextProvider, null, /*#__PURE__*/React.createElement(FilterContextHOC, null, /*#__PURE__*/React.createElement(AutocorrectionProvider, null, /*#__PURE__*/React.createElement(InputContext, {
    forwardRef: forwardRef
  }, /*#__PURE__*/React.createElement(AsyncLoadOnQuery, null), /*#__PURE__*/React.createElement(DialogShownHandler, {
    isExpanded: isExpanded
  }), /*#__PURE__*/React.createElement(DialogDismissedHandler, {
    isExpanded: isExpanded
  }), children)))))))))))))))));
};